import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const PaymentManagement = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Ödeme Yönetimi
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Ödeme yönetimi burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default PaymentManagement;
